import React from 'react';

import { P } from 'xpi-black-ui/Base/Typography';
import Timeline, { TimelineItem } from 'xpi-black-ui/Common/Timeline';

import Container from './styles';

const Sidebar = () => {
  return (
    <Container>
      <P bigger>Fluxo de cotação:</P>
      <Timeline>
        <TimelineItem>Informações iniciais</TimelineItem>
        <TimelineItem>Montagem da estrutura</TimelineItem>
        <TimelineItem>Cotação da estrutura</TimelineItem>
        <TimelineItem>Armazenar cotação</TimelineItem>
      </Timeline>

      <div className="infos">
        <P bigger>Informações importantes:</P>
        <div>
          <P>As cotações realizadas nesta plataforma são de opções flexíveis e europeias.</P>
          <P>As cotações realizadas nesta plataforma não englobam custos de corretagem e taxas cobradas pela bolsa.</P>
          <P>As cotações realizadas nesta plataforma são apenas referências. O preço oficial está suscetível às oscilações de mercado e, por isso, pode sofrer variações. Para contratação e confirmação do preço da operação, favor contatar a mesa sales da XP.</P>
        </div>
      </div>
    </Container>
  );
};

export default Sidebar;
